import React, { useContext } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import CheckoutPageContext from '../../../context/CheckoutPageContext';

function OrderContactOverview() {
  const { control } = useFormContext();
  const { checkoutPageState } = useContext(CheckoutPageContext) || {};
  const { orderContact } = checkoutPageState || {};
  const addressType = orderContact?.addressType || 'homeDelivery';

  const [email, phone] = useWatch({
    control,
    name: [`addresses.${addressType}.email`, `addresses.${addressType}.phone`],
  });

  return (
    <div>
      <p>{phone}</p>
      <p>{email}</p>
      <p>Opted in for Abercrombie & Fitch emails</p>
    </div>
  );
}

export default OrderContactOverview;
